var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box__primary text-center box__header-title",class:{
      'box__header-title-slim': _vm.$route.meta.slimHeader,
      'flex-1-div': ['sm'].includes(_vm.$vuetify.breakpoint.name),
      'box__dark': _vm.$route.meta.type === 'professional',
      'box__light': _vm.$route.meta.type === 'contractor'
    }},[_c('h2',[_vm._v("Recuperação de senha")]),_c('h4',[_vm._v("Informe seu email para receber um link de"),(!['xs'].includes(_vm.$vuetify.breakpoint.name))?_c('br'):_vm._e(),_vm._v("recuperação de senha")])])}
var staticRenderFns = []

export { render, staticRenderFns }